<template>
  <div>
      <iframe :src="url"  frameborder="0" width="100%" :height="iframeHeight" @load="calc($event.target)"></iframe>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
        url:'',
        iframeHeight:'1605'
    };
  },
  created() {
      this.url = this.$route.params.url;
      console.log(this.url,3333)
  },
  mounted() {},
  watch: {},
  computed: {},
  methods: {
        calc(iframe){
            this.iframeHeight = iframe.contentWindow.document.documentElement.scrollHeight
        }
  },
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/pages/dsp/home/customerDetail.vue